/*
 * Custom wishlist page renderer.
 *
 * For each item in Swym's localStorage cache, fetches the pixel-identical
 * PLP card markup via Shopify's Section Rendering API
 * (?section_id=custom-product-card-fragment). This avoids duplicating
 * product-grid-item.liquid logic + ensures qatc, variant chips, badges,
 * secondary image hover, and sale price layout match collection cards
 * exactly.
 *
 * After injection, we flip the .custom-card-heart on each card to
 * aria-pressed="true" so it renders filled (item is in wishlist).
 * Clicking the heart calls swat.removeFromWishList via the shared
 * custom-pdp-wishlist-heart.js handler.
 */
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  var SECTION_URL = '?section_id=custom-product-card-fragment';
  var cardHTMLCache = {};

  function extractHandle(url) {
    var m = url && url.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function readSwymWishlist() {
    try {
      var raw = localStorage.getItem('swym-products');
      if (!raw) return [];
      var data = JSON.parse(raw);
      return ((data && data.all) || []).filter(function (it) { return it && it.et === 4; });
    } catch (e) { return []; }
  }

  function fetchCardHTML(handle) {
    if (cardHTMLCache[handle]) return Promise.resolve(cardHTMLCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + SECTION_URL, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        // Section API wraps in <div id="shopify-section-...">; strip the wrapper
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        var inner = tmp.firstElementChild;
        if (inner && inner.id && inner.id.indexOf('shopify-section') === 0) {
          html = inner.innerHTML;
        }
        cardHTMLCache[handle] = html;
        return html;
      })
      .catch(function () { return ''; });
  }

  function activateHeart(card) {
    var heart = card.querySelector('.custom-card-heart');
    if (!heart) return;
    heart.setAttribute('aria-pressed', 'true');
    var labelRemove = heart.dataset.labelRemove;
    if (labelRemove) heart.setAttribute('aria-label', labelRemove);
  }

  function renderEmpty(grid, emptyState, loading) {
    if (loading) loading.hidden = true;
    grid.hidden = true;
    if (emptyState) emptyState.hidden = false;
  }

  function renderItems(items, grid, emptyState, loading) {
    if (!items.length) {
      grid.innerHTML = '';
      renderEmpty(grid, emptyState, loading);
      return;
    }
    if (emptyState) emptyState.hidden = true;
    if (loading) loading.hidden = true;
    grid.hidden = false;

    // Render placeholders + fetch real HTML
    var placeholders = items.map(function (item, idx) {
      return '<div class="grid__item grid-product small--one-half medium-up--one-quarter pb-wishlist__card pb-wishlist__card--loading" data-pb-card-slot="' + idx + '" data-empi="' + item.empi + '" data-epi="' + item.epi + '"></div>';
    }).join('');
    grid.innerHTML = placeholders;

    items.forEach(function (item, idx) {
      var handle = extractHandle(item.du);
      if (!handle) return;
      fetchCardHTML(handle).then(function (html) {
        var slot = grid.querySelector('[data-pb-card-slot="' + idx + '"]');
        if (!slot || !html) {
          if (slot) slot.remove();
          return;
        }
        // Replace placeholder with fetched card content (just the .grid-product element)
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var card = tmp.querySelector('.grid-product') || tmp.firstElementChild;
        if (!card) {
          slot.remove();
          return;
        }
        // Add our wishlist-card marker class + dataset for the heart toggle
        card.classList.add('pb-wishlist__card');
        card.dataset.empi = item.empi;
        card.dataset.epi = item.epi;
        slot.replaceWith(card);
        // Mark the heart as already in wishlist (clicking will remove)
        activateHeart(card);
      });
    });
  }

  function init() {
    var grid = document.querySelector('[data-pb-wishlist-grid]');
    if (!grid) return;
    var loading = document.querySelector('[data-pb-wishlist-loading]');
    var emptyState = document.querySelector('[data-pb-wishlist-empty]');

    function tryRender() {
      var items = readSwymWishlist();
      renderItems(items, grid, emptyState, loading);
    }

    // Render immediately from localStorage if available
    if (readSwymWishlist().length > 0) {
      tryRender();
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      tryRender();

      // Re-render on Swym lifecycle events
      if (swat.evtLayer && typeof swat.evtLayer.addEventListener === 'function') {
        swat.evtLayer.addEventListener('swym:wishlist-loaded', tryRender);
        swat.evtLayer.addEventListener('swym:wishlist-update', tryRender);
      }
      window.addEventListener('storage', function (e) {
        if (e.key === 'swym-products') tryRender();
      });
      setTimeout(tryRender, 2000);
    });

    // Hard fallback if SDK never loads
    setTimeout(function () {
      if (loading && !loading.hidden) {
        if (!readSwymWishlist().length) renderEmpty(grid, emptyState, loading);
      }
    }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
